import {tableResources, TableResourceType} from "./tables/table-resource-type";
import {modalResources, ModalResourceType} from "./modal-resource-type";
import {selectResources, SelectResourceType} from "./select-resource-type";

export const resources = {
  ...tableResources,
  ...modalResources,
  ...selectResources
};

export type ResourceParams = {
  key: string;
  name: string;
  path: string;
};

export type ResourceTypes =
  TableResourceType |
  ModalResourceType |
  SelectResourceType;
